/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMOJI ANSWER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniqueanswer: {
	},
	graphic: {
		display: 'inline-block',
		textAlign: 'center',
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: pxToEm(-30),
		marginLeft: pxToEm(-30),
		width: pxToEm(60),
		height: pxToEm(60)
	},
	emoji: {
		// emojis used are here https://twitter.github.io/twemoji/preview.html
		// emoji comes from component itself based on switch
		fontSize: '400%',
		position: 'absolute',
		top: '-23%',
		left: '-3%'
	}
};